import { type PropsWithChildren, useMemo } from 'react'

import { ThirdParty, type ThirdPartyConfig } from '@dhl/third-party'
import { getConfig } from '~/config'

export const StartUp = ({ children }: PropsWithChildren) => {
  const { cspNonce, datadog, environment, gtm, oneTrust, version } = getConfig()

  const config: ThirdPartyConfig = {
    oneTrustId: oneTrust.id,
    gmtId: gtm.id,
    virtualPageRootPath: 'account',
    oneTrustNativeEnabled: oneTrust.enableForNative,
    oneTrustNativeEnabledFromVersion: oneTrust.enableForNativeFromVersion,
    nonce: cspNonce,
  }

  const datadogConfig = useMemo(
    () => ({
      ...datadog,
      environment,
      version,
    }),
    [datadog, environment, version]
  )

  return (
    <ThirdParty config={config} datadogConfig={datadogConfig}>
      {children}
    </ThirdParty>
  )
}
